// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingEntity from './entities/hearing.json';
import hearingMenu from '../pages/hearing/menu.json';
import hearingFullForm from '../pages/hearing/forms/full.json';
import hearingContextForm from '../pages/hearing/forms/context.json';
import hearingMiniForm from '../pages/hearing/forms/mini.json';
import hearingLookupForm from '../pages/hearing/forms/lookup.json';
import hearingTableView from '../pages/hearing/views/table.json';
import hearingStagesView from '../pages/hearing/views/stages.json';
import hearingCardsView from '../pages/hearing/views/cards.json';
import hearingSplitView from '../pages/hearing/views/split.json';
import hearingCalendarView from '../pages/hearing/views/calendar.json';
import hearingDashboardView from '../pages/hearing/views/dashboard.json';

/** Тип запису «Слухання» зі сторінками пакета: меню, форми та подання з pages/hearing/. */
export const hearingDefinition: IRecordTypeDefinition = {
  ...hearingEntity,
  views: assembleViewSet({
      table: hearingTableView,
      stages: hearingStagesView,
      cards: hearingCardsView,
      split: hearingSplitView,
      calendar: hearingCalendarView,
      dashboard: hearingDashboardView,
  }),
  form: hearingFullForm,
  forms: { full: hearingFullForm, context: hearingContextForm, mini: hearingMiniForm, lookup: hearingLookupForm },
  menu: hearingMenu,
} as IRecordTypeDefinition;
